function isPhaseIn(phaseInDate) {
  if (phaseInDate === null) return;
  const date = new Date(phaseInDate);
  const msThreshold = 1000 * 60 * 60 * 24 * 30;
  const diff = new Date().getTime() - date;
  return diff > 0 && diff !== null && diff <= msThreshold;
}

function isPhaseOut(phaseOutDate) {
  if (phaseOutDate === null) return;
  return new Date(phaseOutDate) <= Date.now();
}

function isPreCr(phaseInDate) {
  if (phaseInDate === null) return;
  return new Date(phaseInDate) > Date.now();
}

export { isPhaseIn, isPhaseOut, isPreCr };
